import { Table } from "react-bootstrap";

export function TableReport({ children }) {
  return <Table striped>
    {children}
  </Table>
}
